import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Button, ButtonSize, ButtonVariant, Text, TextSize, TextWeight } from "../../components";
import OrderConfirmationImage from "./order-confirmation.png";
export const OrderConfirmation = t0 => {
  const $ = _c(6);
  const {
    orderId
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={OrderConfirmationImage} alt="Order Confirmation" width={46} height={60} />;
    t2 = <Text text={"Zam\xF3wienie zosta\u0142o z\u0142o\u017Cone"} weight={TextWeight.BOLD} className="my-4" />;
    t3 = <Text text={"Twoje zam\xF3wienie zosta\u0142o z\u0142o\u017Cone pomy\u015Blnie. O post\u0119pach jego realizacji poinformujemy Ci\u0119 na adres email podany podczas sk\u0142adania zam\xF3wienia."} className="max-w-[400px] text-center" fontSize={TextSize.S} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = `/historia-zamowien/${orderId}`;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button text={"Przejd\u017A do zam\xF3wienia"} variant={ButtonVariant.SECONDARY} size={ButtonSize.S} className="mt-4 !px-8" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <div className="w-full max-w-screen-2xl mx-auto h-[calc(100%-37px)] py-8"><div className="flex flex-col items-center justify-center my-[10%] col-span-1 lg:col-span-8">{t1}{t2}{t3}<Link href={t4}>{t5}</Link></div></div>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};